// extracted by mini-css-extract-plugin
module.exports = {"stripe-setup-button__btn":"styles_stripe-setup-button__btn__BkaHR"};